import React, {useState, Fragment} from 'react';
import styles from  './wealthiest-cities.module.scss'; 
import { dataCountryOverview } from '../../utils/convert';
import { formatNumberWithDot } from '../../utils/utils';
import CountryFlag from '../common/countryFlag/country-flag';
import ProgressBar from '../common/progressBar/progress-bar.module';
import SelectDropdown from '../common/selectDropdown/select-dropdown';
import IconSort from '../common/icon/icon-sort';

const options = [
    {label:"HNWIs (USD 1m+)", value:"millionaires"},
    {label:"Centi-millionaires (USD 100m+)", value:"centiMillionaires"},
    {label:"Billionaires (USD 1bn+)", value:"billionaires"},
    {label:"HNWI growth % (2012 to 2022)", value:"HNWIGrowth"}
];


const WealthiestCities = () =>{


    const [sortColumn, setSortColumn] = useState("millionaires");
    const [display, setDisplay] = useState();

    const handleOptionSelect = (option) => {
        // setSelectedOption(option);
        setSortColumn(option.value);
        setDisplay(-1);
    };

    const handleSort = (columnName) => {
        setSortColumn(columnName);
        setDisplay(-1);
    };

    const sortedData = sortColumn
    ? dataCountryOverview().sort((a, b) => b[sortColumn] - a[sortColumn])
    : dataCountryOverview();

    const handleMobileRowClick = (index) =>{
        setDisplay(index);
    }


    return( 
        <>  
            <h2 className="mb-5">Which cities have the fastest-growing millionaire populations?</h2>
            <div className={`d-md-none ${styles.sortMobileWrapper}`}>
                <div className={styles.sortTitle}>Sort by</div>
                <SelectDropdown options={options} onSelect={handleOptionSelect} />
            </div>
            <table className={`chartTable ${styles.wealthChartTable}`}>
                <thead>
                    <tr>
                        <th className={styles.cityColumn} width="9%">City/Area</th>
                        <th className={styles.cellHideMobile} width="12%">Country</th>
                        <th 
                            className={`${styles.cellHideMobile}  ${styles.sortableColumn} ${sortColumn === 'HNWIGrowth'? styles.selectedColumn: ''} ${styles.hwmiGrowthColumn}`}
                            onClick={() => handleSort("HNWIGrowth")}
                            colSpan="2"
                        >
                            <div className={styles.sortColumnTitle}>
                                <span className={styles.sortColumnTitleText}>HNWI growth %<br />(2012 to 2022)</span>
                                <IconSort />
                            </div>
                        </th>
                        <th 
                            className={`text-right ${styles.cellHideMobile} ${styles.sortableColumn} ${sortColumn === 'millionaires'? styles.selectedColumn: ''}`}
                            onClick={() => handleSort("millionaires")}
                        >
                            <div className={styles.sortColumnTitle}>
                                <span className={styles.sortColumnTitleText}>HNWIs<br />(USD 1m+)</span>
                                <IconSort />
                            </div>
                        </th>
                        <th 
                            className={
                                `text-right 
                                ${styles.cellHideMobile}  
                                ${styles.sortableColumn} 
                                ${sortColumn === 'centiMillionaires'? styles.selectedColumn: ''}`
                            }
                            onClick={() => handleSort("centiMillionaires")}
                        >
                            <div className={styles.sortColumnTitle}>
                                <span className={styles.sortColumnTitleText}>Centi-millionaires<br />(USD 100m+)</span>
                                <IconSort />
                            </div>
                        </th>
                        <th 
                            className={`text-right ${styles.cellHideMobile}  ${styles.sortableColumn} ${sortColumn === 'billionaires'? styles.selectedColumn: ''}`}
                            onClick={() => handleSort("billionaires")}
                        >
                            <div className={styles.sortColumnTitle}>
                                <span className={styles.sortColumnTitleText}>Billionaires<br />(USD 1bn+)</span>
                                <IconSort />
                            </div>
                        </th>
                        
                        <th className={`text-right ${styles.cellHideMobile}`}>Residence by<br /> investment options</th>
                    </tr>
                </thead>
                <tbody>
                    {sortedData.map((item, index) => (
                        <Fragment key={index}>
                            <tr onClick={()=>handleMobileRowClick(index)} className={`${styles.contentRow} ${index===display? styles.openedRow: ''}`}>
                                <td>{item.city}</td>
                                <td className={styles.cellHideMobile}>
                                    <CountryFlag country={item.country} />
                                </td>
                                <td className={`text-right ${styles.cellHideMobile} ${styles.sortableColumn} ${sortColumn === 'HNWIGrowth'? styles.selectedColumn: ''} ${styles.percentMinusColumn}`}>
                                    <ProgressBar 
                                        type="left" 
                                        percentValue={item.HNWIGrowth < 0 ? item.HNWIGrowth: 0}
                                    />
                                </td>
                                <td className={`text-right ${styles.cellHideMobile} ${styles.sortableColumn} ${sortColumn === 'HNWIGrowth'? styles.selectedColumn: ''} ${styles.percentColumn}`}>
                                    <ProgressBar 
                                        percentValue={item.HNWIGrowth > 0 ? item.HNWIGrowth: 0} 
                                        labelText={item.HNWIGrowth + "%"} 
                                    />
                                </td>
                                <td className={`text-right ${styles.cellHideMobile} ${styles.sortableColumn} ${sortColumn === 'millionaires'? styles.selectedColumn: ''}`}>                  
                                    {formatNumberWithDot(item.millionaires)}
                                </td>
                                <td className={`text-right ${styles.cellHideMobile} ${styles.sortableColumn} ${sortColumn === 'centiMillionaires'? styles.selectedColumn: ''}`}>{item.centiMillionaires}</td>
                                <td className={`text-right ${styles.cellHideMobile} ${styles.sortableColumn} ${sortColumn === 'billionaires'? styles.selectedColumn: ''}`}>{item.billionaires}</td>
                                
                                <td className={`text-right ${styles.cellHideMobile}`}>
                                    {item.link && (
                                        <a href={item.link} target="_blank" className={styles.linkText} rel="noreferrer">Find out more</a>
                                    )}
                                    
                                </td>
                            </tr>
                            {index === display &&(
                                <tr className={`${styles.hiddenTableRow}`}>
                                    <td>
                                        <CountryFlag country={item.country} />
                                    </td>
                                    {sortColumn === 'HNWIGrowth' &&(
                                        <td className={`${styles.sortableColumn} ${styles.selectedColumn}  ${styles.percentMinusColumn}`}></td>
                                    )}
                                    <td className={`text-right ${styles.sortableColumn} ${styles.selectedColumn}`}>
                                        {item.link && (
                                            <>
                                            Residence by investment<br />
                                            <a href={item.link} target="_blank" className={`${styles.linkText} mt-1 d-inline-block`} rel="noreferrer">Find out more</a>
                                            </>
                                        )}
                                    </td>
                                </tr>
                            )}
                           
                        </Fragment>
                    ))}
                </tbody>
            </table>

            <div className="footer-note mt-5">
                    <ul>
                      <li>All figures are for 31 December 2022.</li>
                      <li>‘High-net-worth individuals’ or ‘HNWIs’ refer to individuals with investable wealth of USD 1 million or more.</li>
                      <li>Includes only HNWIs living in each city (residents).</li>
                      <li>HNWI figures rounded to nearest 100.</li>
                      <li>The Bay Area includes San Francisco and Silicon Valley. For Zurich and Geneva we refer to the canton rather than the city.</li>
                    </ul>
                    <p>Source: New World Wealth</p>
            </div>
        </>
    )
}

export default WealthiestCities;